import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=52109cc1&scoped=true&"
import script from "./AddShop.vue?vue&type=script&lang=js&"
export * from "./AddShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52109cc1",
  null
  
)

export default component.exports